import useStep2 from "./useStep2"
import { StepsProps } from "../types";
import { DataTable, FormSectionHeader, Loader } from "@/components";
import { ArrowDownToLine, FileText } from "lucide-react";
import { Badge, Button } from "@/components/ui";
import { cn } from "@/lib/utils";
import { statusOptions } from "../../consts";

const Step2 = ({onPreviousStepClick, onNextStepClick, onBackClick}: StepsProps) => {
  const {
    communityName,
    bulkUploadDtl,
    summaryCards,
    columns,
    onFilterChange,
    tableData,
    activeFilter,
    onImport,
    isUploadPending,
    duplicateRows,
    enableButton,
    importCount
  } = useStep2({onNextStepClick});
  
  return (
    <>
      <div className="bg-white p-4 rounded-md my-5">
        <div>
          <FormSectionHeader className="text-[18px]" wrapperClassName="mb-0">Review & Validate Upload</FormSectionHeader>
          <span className="text-[12px] text-gray-400">Importing to {communityName}. We checked every row against the template and your community masters.</span>
        </div>

        <div className="border-1 border-gray-200 p-3 mt-3 rounded-md flex flex-row items-center justify-between">
          <div className="flex flex-row items-center gap-2">
            <div className="bg-green-50 rounded-md p-2">
              <FileText className="stroke-green-600"/>
            </div>
            <div className="flex flex-col">
              <span className="text-[14px] font-normal">{bulkUploadDtl?.fileName}</span>
              <span className="text-[12px] font-normal text-gray-400">{bulkUploadDtl?.totalRows} rows detected</span>
            </div>
          </div>
          <Button variant="link" onClick={onPreviousStepClick}>Replace File</Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[20px]">
        {summaryCards?.map((data: any) => {
          return (
            <div className={cn(data?.className, "rounded-md pb-2")}>
              <div className="bg-white flex flex-col rounded-md p-4">
                <span className={cn("text-[24px] font-medium", data?.textClassName)}>{data?.count}</span>
                <span className="text-[12px]">{data?.title}</span>
              </div>
            </div>
          )
        })}
      </div>

      <div className="my-5">
        <div className="flex flex-row justify-between">
          <div className="flex flex-row gap-3">
            <FormSectionHeader>Row-by-row Results</FormSectionHeader>
            {statusOptions?.map((data: any) =>
              <Badge className={cn(
                "rounded-full min-w-[70px] h-[30px] cursor-pointer border-1 border-gray-200",
                data?.value == activeFilter ? "" : "bg-white text-black",
                "transition-all duration-150 active:scale-95 ease-out"
              )}
                onClick={() => onFilterChange(data?.value)}>
                {data?.value != "all" ? <div className={cn("rounded-full h-2 w-2", data?.indicator)} /> : <></>} {data?.label}
              </Badge>)
            }
          </div>
          <Button variant="link"><ArrowDownToLine />Download Error report</Button>
        </div>
        <DataTable data={tableData || []} columns={columns} />
        <div className="text-[14px] font-thin my-4"><span className="font-semibold">{importCount} of {bulkUploadDtl?.totalRows}</span> rows will be imported. Rows with errors are skipped — fix them in the file and re-upload, or import the valid ones now.</div>

        <div className="my-4 flex flex-row items-center justify-end gap-4">
          <Button variant="outline" disabled={isUploadPending} onClick={onBackClick}>Cancel</Button>
          {duplicateRows?.length ?
            <Button onClick={onNextStepClick}>Resolve {duplicateRows?.length} Duplicates</Button> 
            : <Button disabled={isUploadPending || !enableButton} onClick={onImport}>
                {isUploadPending ? <Loader variant="secondary" /> : <></>}
                Import {importCount} valid rows
              </Button>
          }
        </div>
      </div>
    </>
  )
}

export default Step2;